import React from "react"
import { Helmet } from "react-helmet"

// Global styles and component-specific styles.
import "./global.css"
import styles from "./main.module.css"

const Layout = ({ children }) => (



  <div>
    <Helmet title="Iisha Small Interactive Developer/Designer" />
   
    <main className={styles.main} style={{margin: '0 auto',
            width: '100%',
            height: '500px',
            overflow:'visible',
            padding: '0'
            }}>{children}</main>
  </div>
 
)

export default Layout
